class FaqsPage {
  constructor(section) {
    this.section = section;
    this.searchInput = section.querySelector('[data-faq-search]');
    this.categoryButtons = Array.from(section.querySelectorAll('[data-faq-category]'));
    this.groups = Array.from(section.querySelectorAll('[data-faq-group]'));
    this.items = Array.from(section.querySelectorAll('[data-faq-item]'));
    this.toggles = Array.from(section.querySelectorAll('[data-faq-toggle]'));
    this.emptyState = section.querySelector('[data-faq-empty]');
    this.activeCategory = 'all';
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.bindEvents();
    this.applyFilters();
  }

  bindEvents() {
    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.faqCategory || 'all';
        this.updateActiveCategory();
        this.applyFilters();
      });
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.applyFilters());
    }

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => this.toggleAccordion(toggle));
    });

    window.addEventListener('resize', () => this.refreshOpenPanels());
  }

  updateActiveCategory() {
    this.categoryButtons.forEach((button) => {
      const isActive = button.dataset.faqCategory === this.activeCategory;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive.toString());
    });
  }

  applyFilters() {
    const query = this.searchInput ? this.searchInput.value.trim().toLowerCase() : '';
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matchesCategory = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
      const matchesSearch = !query || (item.dataset.searchText || '').includes(query);
      const shouldShow = matchesCategory && matchesSearch;

      item.hidden = !shouldShow;

      if (!shouldShow) {
        const toggle = item.querySelector('[data-faq-toggle]');
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
          this.closeAccordion(toggle, true);
        }
      } else {
        visibleCount += 1;
      }
    });

    this.groups.forEach((group) => {
      const hasVisibleItems = Boolean(group.querySelector('[data-faq-item]:not([hidden])'));
      group.hidden = !hasVisibleItems;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount > 0;
    }
  }

  toggleAccordion(toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeAccordion(toggle);
    } else {
      this.openAccordion(toggle);
    }
  }

  openAccordion(toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    toggle.setAttribute('aria-expanded', 'true');

    if (this.prefersReducedMotion) {
      panel.style.height = 'auto';
      return;
    }

    panel.style.height = 'auto';
    const panelHeight = panel.scrollHeight;
    panel.style.height = '0px';

    requestAnimationFrame(() => {
      panel.style.height = `${panelHeight}px`;
    });

    panel.addEventListener(
      'transitionend',
      () => {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          panel.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  closeAccordion(toggle, immediate = false) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    toggle.setAttribute('aria-expanded', 'false');

    if (this.prefersReducedMotion || immediate) {
      panel.style.height = '0px';
      return;
    }

    panel.style.height = `${panel.scrollHeight}px`;

    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });
  }

  refreshOpenPanels() {
    this.toggles.forEach((toggle) => {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) {
        panel.style.height = 'auto';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faqs-page]').forEach((section) => {
    new FaqsPage(section);
  });
});
